import type { InventoryItemResponse, InventoryListResponse, InventoryProductCreatePayload } from '@/types/Api/Inventory'
import type { InventoryProduct } from '@/types/Models/InventoryProduct'
import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class InventoryProductsProxy
  extends BaseProxy
  implements ProxyMethods<InventoryListResponse<InventoryProduct>>
{
  public endpoint = 'products'
  public hostname = import.meta.env.VITE_APP_INVENTORY_API

  all(): Promise<InventoryListResponse<InventoryProduct>> {
    return this.submit('get', `${this.hostname}/${this.endpoint}`)
  }

  find(id: string | number): Promise<InventoryItemResponse<InventoryProduct>> {
    return this.submit('get', `${this.hostname}/${this.endpoint}/${id}`)
  }

  create(item: InventoryProductCreatePayload): Promise<InventoryItemResponse<InventoryProduct>> {
    return this.submit('post', `${this.hostname}/${this.endpoint}`, item)
  }
}
